import { BCMSDate, BCMSRecord, useBCMSContext, useParams, Workflow } from "@bcm-dev/bcms-vite";
import Classes, { Account, ACHBatch, CompanyAccount, Participant } from "model";
import React from "react";

import OneTimeACHPaymentPage from "components/pages/OneTimeACHPaymentPage";
import SoftTokensActivateTokenInfoPage from "components/pages/SoftTokensActivateTokenInfoPage";
import SoftTokensActivateTokenRegisterCodePage from "components/pages/SoftTokensActivateTokenRegisterCodePage";
import SoftTokensActivateTokenActivationPage from "components/pages/SoftTokensActivateTokenActivationPage";
import SoftTokensActivateTokenCompletionPage from "components/pages/SoftTokensActivateTokenCompletionPage";
import PasswordChangeRequiredPage from "components/pages/PasswordChangeRequiredPage";

// Steps of the workflow
const steps = [ 
    SoftTokensActivateTokenInfoPage, 
    SoftTokensActivateTokenRegisterCodePage,
    SoftTokensActivateTokenActivationPage,
    SoftTokensActivateTokenCompletionPage,
    PasswordChangeRequiredPage
 ];

/**
 * @function SoftTokensActivateTokenWorkflow
 * @returns {React.Component}
 * @exported true
 * @description The main workflow component for "soft tokens activation".
 * @example
 * <SoftTokensActivateTokenWorkflow />
 */
export default function SoftTokensActivateTokenWorkflow(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { stepID } = useParams();

    const value = getDefaultData();
    return <Workflow value={ value } steps={ steps } step={ stepID }  />
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @exported true
 * @description Hook to return the steps of the workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultData
 * @returns {OBJECT}
 * @exported true
 * @description Hook to return the default state of the workflow
 */
export const getDefaultData = () => {
    return {
        data: {
            
        },
        ui: {
            
        }
    }
};